// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Upload {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  align-items: flex-start;
  text-align: left;
  overflow: hidden;
}

.Content {
  display: flex;
  flex-direction: row;
  padding-top: 16px;
  box-sizing: border-box;
  width: 100%;
}

.Files {
  margin-left: 32px;
  align-items: flex-start;
  justify-items: flex-start;
  flex: 1 1;
  overflow-y: auto;
}

.Actions {
  display: flex;
  flex: 1 1;
  width: 100%;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 32px;
}

.Title {
  margin-bottom: 32px;
  color: #555;
}

.Filename {
  margin-bottom: 8px;
  font-size: 16px;
  color: #555;
}

.Row {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: space-between;
  height: 65px;
  padding: 8px;
  overflow: hidden;
  box-sizing: border-box;
}

.CheckIcon {
  opacity: 0.5;
  margin-left: 32px;
}

.ProgressWrapper {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  align-items: center;
}

button.upload {
  font-family: "Roboto medium", sans-serif;
  font-size: 14px;
  display: inline-block;
  height: 36px;
  min-width: 88px;
  padding: 6px 16px;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: 0;
  border-radius: 2px;
  background: #ffba01;
  color: #000000;
  outline: 0;
}

button:disabled {
  background: rgb(189, 189, 189);
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/upload.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EAEtB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EAGzB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".Upload {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: flex-start;\n  text-align: left;\n  overflow: hidden;\n}\n\n.Content {\n  display: flex;\n  flex-direction: row;\n  padding-top: 16px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.Files {\n  margin-left: 32px;\n  align-items: flex-start;\n  justify-items: flex-start;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.Actions {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  align-items: flex-end;\n  flex-direction: column;\n  margin-top: 32px;\n}\n\n.Title {\n  margin-bottom: 32px;\n  color: #555;\n}\n\n.Filename {\n  margin-bottom: 8px;\n  font-size: 16px;\n  color: #555;\n}\n\n.Row {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 65px;\n  padding: 8px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.CheckIcon {\n  opacity: 0.5;\n  margin-left: 32px;\n}\n\n.ProgressWrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n}\n\nbutton.upload {\n  font-family: \"Roboto medium\", sans-serif;\n  font-size: 14px;\n  display: inline-block;\n  height: 36px;\n  min-width: 88px;\n  padding: 6px 16px;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 0;\n  border-radius: 2px;\n  background: #ffba01;\n  color: #000000;\n  outline: 0;\n}\n\nbutton:disabled {\n  background: rgb(189, 189, 189);\n  cursor: default;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
